/*This controller function will perform diffrent operations like Closing Pop, Cancelling Booking
    ,and processing an ajax request*/

(function () {

    'use strict';

    var BookingCtrl = function ($scope, ajaxCall, xmsNotificationFactory, $uibModalInstance, passedModel, $http) {
        var _this = this;

        console.log('BookingCtrl init!');
        if (!angular.isDefined(passedModel)) {
            passedModel = {};
        }
        $scope.ngModel = passedModel;

        /*This method will close popup*/
        $scope.cancel = function (e) {
            if (angular.isDefined(e)) {
                e.preventDefault();
            }
            $uibModalInstance.dismiss('cancel');
        };

        var notificationAndCancel = function(resultData){
            xmsNotificationFactory.addObj({id: "cancelBookingPop", type: resultData.responseType, bodyHtml: resultData.responseMessage, timeout:10});
            $scope.cancel();
        };

        /**
         * This method will do an ajax call to cancel booking
         * @param $event
         * @param url - Current usage "/booking/cancelBookingAction/{id}" or "/booking/cancelBookingAndReplace/{id}"
         * @param id
         * @returns {boolean}
         */
        $scope.cancelBooking = function ($event, url) {
            var ajaxUrl = WEBAPP_PATH + url;

            ajaxCall.getData(ajaxUrl).then(
                function(result) {

                    if (result.data.responseType == "success") {
                        notificationAndCancel(result.data);
                    }
                    else if (result.data.responseType == "error") {
                        notificationAndCancel(result.data);
                    }

                }
            );
            return false;
        };

    };
    BookingCtrl.$inject = ['$scope', 'ajaxCall', 'xmsNotificationFactory', '$uibModalInstance', 'params', '$http'];
    angular.module('app').controller('BookingCtrl', BookingCtrl);

}());